'use client';

import React from 'react';

import { isDesktop } from 'react-device-detect';

import Layout from '@/common/components/layout';
import { DefaultFooter } from '@/common/components/themes/footers/default-footer';
import Wrapper from '@/common/components/wrapper';

import Main from './components/main.component';

const ContactUs = () => {
  return (
    <Layout responsiveAppbar={isDesktop}>
      <Wrapper className="mx-auto mb-20 mt-10 max-w-[1040px] rounded-2xl border border-silver-300 bg-white px-4 md:px-8 pb-8 pt-10">
        <Main />
      </Wrapper>
      <DefaultFooter />
    </Layout>
  );
};

export default ContactUs;
